import img_1 from "./img/img_1.png";
import img_7 from "./img/img_7.jpg";

const collections = [
  {
    name: "The Classic Fit",
    image: img_1,
    description: "Timeless straight-cut jeans for everyday confidence.",
  },
  {
    name: "Slim & Modern",
    image: img_1,
    description: "Contemporary slim fits for a sharp, streamlined look.",
  },
  {
    name: "Eco-Denim",
    image: img_1,
    description:
      "Sustainable jeans made with organic cotton and eco-friendly dyes.",
  },
  {
    name: "Indore Edition",
    image: img_1,
    description:
      "Exclusive designs inspired by the heritage and energy of our home city.",
  },
  {
    name: "Weekend Comfort",
    image: img_1,
    description: "Relaxed fits perfect for casual outings and leisure days.",
  },
];

const bestSelling = [
  {
    name: "Men’s Vintage Straight Fit",
    image: img_7,
    price: "₹ 19.99",
    description: "The everyday essential",
  },
  {
    name: "Women’s High-Waist Slim",
    image: img_7,
    price: "₹ 19.99",
    description: "Flattering, flexible, fashionable",
  },
  {
    name: "Men’s Dark Wash Tapered",
    image: img_7,
    price: "₹ 19.99",
    description: "Office to outing versatility",
  },
  {
    name: "Women’s Boyfriend Fit",
    image: img_7,
    price: "₹ 19.99",
    description: "Effortlessly cool and comfortable",
  },
];

export { collections, bestSelling };
